import { IPaymentDictionariesAccepted } from '../../../actions/paymentDictionary/loadDictionaries'
import { IPaymentDictionaryStore } from '../index'

export default function(
  store: IPaymentDictionaryStore,
  action: IPaymentDictionariesAccepted,
): IPaymentDictionaryStore {
  return {
    ...store,
    dictionaries: action.dictionaries,
    request: {
      ...store.request,
      errMessage: '',
      isLoading: false,
    },
  }
}
